export const figure46 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    spacingBottom: 45,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    marginleft:200,
    type: 'bar',
    height: '600px',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false,
  }, 
  exporting: {
    enabled: false
  },
  colors: ['#5b9bd5', '#ed7d31'],
  xAxis: {
      categories: [
        "Monde",
        "",
        "Petits États insulaires en développement (PEID)",
        "Pays en développement sans littoral (PDSL)",
        "Pays les moins avancés (PMA)",
        "",
        "Afrique subsaharienne",
        "Océanie (hors Australie et Nouvelle-Zélande)",
        "Afrique du Nord et Asie de l’Ouest",
        "Amérique latine et Caraïbes",
        "Europe et Amérique du Nord",
        "Asie de l’Est et du Sud-Est",
        "Asie centrale et du Sud",
        "Australie et Nouvelle-Zélande",
  ],
      crosshair: true
  },
  yAxis: {
      max: 25,
      min: 0,
      tickInterval: 5,
      title: {
          text: null
      }
  },
  tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td> ' +
          '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
  },
  plotOptions: {
      column: {
          pointPadding: 0,
          borderWidth: 0
      }
  },
  series: [
  {dataLabels: {
    enabled: false,},
      name: 'Food loss estimates',
      data: [
         {y: 13.3, color: '#ed7d31'},
         {y: 0, color: ''},
          {y: 17.3, color: '#5b9bd5'},
          {y: 14.9, color: '#5b9bd5'},
          {y: 18.9, color: '#5b9bd5'},
          {y: 0, color: ''},
          {y: 21.4, color: '#5b9bd5'},
          {y: 14.8, color: '#5b9bd5'},
          {y: 14.8, color: '#5b9bd5'},
          {y: 12.3, color: '#5b9bd5'},
          {y: 9.9, color: '#5b9bd5'},
          {y: 15.1, color: '#5b9bd5'},
          {y: 13.6, color: '#5b9bd5'},
          {y: 13.6, color: '#5b9bd5'},
        
      ]
  
  },
  ]
}
